module.exports = __webpack_public_path__ + "img/himg1.f15ec736.png";